export default __webpack_public_path__ + "c8ca6e4b9d8f934c48c24df648560351.jpg";